<template>
  <div class="page-content">
    <div class="flex-view">
      <img src="@/assets/images/clubs/img01.png" alt="" />
      <div class="view-info">
        <div class="page-title">Introductions</div>
        <div class="text">
          <b class="sub-title">WHAT ARE UNESCO CLUBS?</b>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p>The Clubs and Associations for UNESCO are groups of volunteers of different ages and
          socio-professional status who become activists in the service of UNESCO’s ideals.</p>
          <p>Established under the aegis of the National Commissions for UNESCO, Clubs and Associations
          are grouped into national, regional and international networks, for the purpose of acting
          in UNESCO’s fields of competence at the grass root level.</p>
          <p>In the light of civil society’s growing role in determining public policy, UNESCO’s
          Medium-Term Strategies stress the main role that Clubs and Associations for UNESCO can
          play in the sustainable development process, in cooperation with other civil society
          partners.</p>
          <p>The activities carried out by the Clubs and Associations are varied and depend, very
          often, on the interests of their members and also on the financial resources and means of
          action available. Irrespective of their nature and scope, these initiatives foster the
          dissemination of UNESCO’s principles and objectives in civil society. These Clubs
          therefore make it possible to publicize the values represented by the Organization in
          local communities. In the light of civil society's growing role in public policy-making,
          the Club movement can play a key part in educating citizens, and can contribute to
          dialogue between cultures and generations for sustainable development.At the national
          level, UNESCO Clubs are coordinated either by a National Federation if there are or by the
          National Commission in that country. At the regional level, regional federations as
          coordinating bodies carry out activities in promoting clubs movement across the regions.
          At the international level, the World Federation of UNESCO Clubs and Associations (WFUCA),
          as an international NGO in official partnership (associate status) with UNESCO, is
          responsible for informing, coordinating and mobilizing its members, with UNESCO's support
          and cooperation.</p>
          <b class="sub-title">Clubs for UNESCO have three main functions:</b>
          <p><b class="mr" style="margin-right: 20px">•</b>Training</p>
          <p><b  class="mr" style="margin-right: 20px">•</b>Information</p>
          <p><b  class="mr" style="margin-right: 20px">•</b>Action</p>
          <p>They take up a position on global problems with local repercussions and thus contribute to
          the process of reflection on social priorities.</p>

          <b class="sub-title">Activities</b>
          <p>Some examples of the Clubs’ action:</p>
          <p><b  class="mr" style="margin-right: 20px">•</b>Dissemination of general principles such as those set
          out in the Preamble to the Constitution of UNESCO, the United Nations Charter and the
          Universal Declaration of Human Rights;</p>
          <p><b  class="mr" style="margin-right: 20px">•</b>Participation in the celebration of international days
          and years proclaimed by the General Assembly of the United Nations and the General
          Conference of UNESCO;</p>
          <p><b  class="mr" style="margin-right: 20px">•</b>Promotion of literacy activities, preservation and
          presentation of the cultural heritage.</p>
          <p><b  class="mr" style="margin-right: 20px">•</b>Organization of study camps for young people.</p>
          <p> <b  class="mr" style="margin-right: 20px">•</b>Education on promoting gender equality, combating
          climate change, and preventing AIDS.</p>
          <p><b  class="mr" style="margin-right: 20px">•</b>Publication of newsletters and information
          documents.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.mobile {
  .page-content {
    font-size: fh(16vh, pc);
    line-height: fh(26vh, h5) !important;
    .page-title {
      font-size: fh(36vh, pc);
      line-height: 20px;
    }
    .flex-view {
      width: 100%;
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      img {
        width: 100%;
        display: block;
        margin-right: 0;
      }
      .view-info {
        font-size: fh(16vh, pc);
        line-height: fh(26vh, h5) !important;
        margin-top: 20px;
        flex: 1;
        .text {
          margin-top: 0;
          .sub-title {
            display: block;
            margin: 10px 0;
          }
          .mr {
            margin-right: 10px !important;
          }
        }
      }
    }
  }
}
.page-content {
  width: 100%;
  > img {
    width: fw(400vw, pc);
    height: fw(400vw, pc);
    display: block;
  }
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(42vh, pc);
    text-align: justify;
  }
  .text {
    margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
    p {
      margin: 6px 0;
    }
    .sub-title {
      display: block;
      margin-top: 18px;
    }
  }
  .flex-view {
    width: 100%;
    display: flex;
    align-items: flex-start;
    img {
      width: fw(360vw, pc);
      display: block;
      margin-right: fw(20vw, pc);
    }
    .view-info {
      flex: 1;
      .text {
        margin-top: fh(12vh, pc);
      }
    }
  }
}
</style>
